import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AIDisclosureService } from '@/services/ai-disclosure/service/ai-disclosure.service';
import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import type { AIDisclosureState } from '@/services/ai-disclosure/type/ai-disclosure.type';
import { useDisposes } from '@/composables/use-disposes';

export const useAiDisclosure = createSharedComposable(() => {
    const aiDisclosureService = injectService<AIDisclosureService>(AIDisclosureService);
    const aiDisclosureData = ref<AIDisclosureState>(aiDisclosureService.getModelData());

    const updateState = (states: AIDisclosureState) => {
        aiDisclosureData.value = states;
    };

    aiDisclosureService.onStatesChange(updateState);

    const { disposes } = useDisposes();
    disposes.push(
        aiDisclosureService.onStatesChange(updateState)
    );

    return {
        aiDisclosureService,
        aiDisclosureData,
    };
});
